import { routesIntlMapping } from '@buy-viasat/redux/src/navigator';
import { SelectedInstallation } from '@buy-viasat/redux/src/schedule-installation';
import { WorkOrderInformation, ScheduleR0 } from '@buy-viasat/types/build/bv';
import { OnSiteContactInformation } from '@buy-viasat/types/src/bv';
import { MeridiemIndicator } from './types';

export const toPascalCase = (stringToConvert: string): string => {
  const routeAlias = routesIntlMapping[stringToConvert] || stringToConvert;

  return `${routeAlias.charAt(0).toUpperCase()}${routeAlias.slice(1)}`;
};

const convertTo12HourFormat = (timeIn24hFormat: number): number => {
  if (timeIn24hFormat === 0) {
    return 12; // Midnight
  }
  if (timeIn24hFormat > 12) {
    return timeIn24hFormat - 12; // PM hours
  }
  return timeIn24hFormat; // AM hours (1-12)
};

const getMeridiemIndicator = (timeIn24hFormat: number): MeridiemIndicator => {
  return timeIn24hFormat >= 12 ? MeridiemIndicator.PM : MeridiemIndicator.AM;
};

const formatTimeWindow = (startHour: number, endHour: number): string => {
  const startTime12Hour = convertTo12HourFormat(startHour);
  const endTime12Hour = convertTo12HourFormat(endHour);
  const meridiem = getMeridiemIndicator(endHour);

  return `${startTime12Hour}-${endTime12Hour} ${meridiem}`;
};

export const constructWorkOrderInformation = (
  installationDateValue: SelectedInstallation,
  PALInstallationDates: ScheduleR0[],
  onSiteContactInformation?: OnSiteContactInformation,
): WorkOrderInformation | null => {
  if (!installationDateValue.year) {
    return null;
  }

  const { year, day, month, note, arrivalWindow } = installationDateValue;
  if (year == null || month == null || day == null) return null;

  // Find matching schedule from PALInstallationDates
  const matchingSchedule = PALInstallationDates.find((schedule) => {
    const scheduleDate = new Date(schedule.from);
    const scheduleMonth = scheduleDate.getMonth() + 1; // getMonth() is 0-indexed
    const scheduleDay = scheduleDate.getDate();
    const scheduleYear = scheduleDate.getFullYear();

    // Check if date matches
    if (scheduleMonth === month && scheduleDay === day && scheduleYear === year) {
      const fromDate = new Date(schedule.from);
      const toDate = new Date(schedule.to);
      const fromHour = fromDate.getHours();
      const toHour = toDate.getHours();

      const scheduleTimeWindow = formatTimeWindow(fromHour, toHour);
      return scheduleTimeWindow === arrivalWindow;
    }
    return false;
  });

  if (!matchingSchedule) return null;

  return {
    appointment: {
      startTime: matchingSchedule.from,
      endTime: matchingSchedule.to,
    },
    notes: `${onSiteContactInformation?.firstName} ${onSiteContactInformation?.lastName}, ${onSiteContactInformation?.email}, ${onSiteContactInformation?.phoneNumber}, ${note}`,
    onSiteContactInformation,
  };
};
